module.exports = __webpack_public_path__ + "assets/images/upgrade-graphic-premium@3x-2c057b83aaae5e364e3bfd6fcb96613d.jpg";